import React from 'react';
import PropTypes from 'prop-types';

const ColorSelector = ({
                         colorInfo,
                         currentColorId,
                         changeColor,
                         showColorInfo,
                         hideColorInfo,
                       }) => {
  return (
    <div className="ExteriorView__color-selector">
      <ul className="ExteriorView__color-selector__list">
        {colorInfo.map((color, index) => {
          return (
            <li key={index}>
              <a className={'ExteriorView__color-selector__link' + ((currentColorId === color.code) ? ' current': '')}
                 style={{backgroundColor: '#' + color.rgb}}
                 href="javascript:void(0)"
                 onClick={(e) => {
                   e.preventDefault();
                   if (changeColor) changeColor(color.code);
                 }}
                 onMouseEnter={(e) => {
                   e.preventDefault();
                   if (showColorInfo) showColorInfo(color.code);
                 }}
                 onMouseLeave={(e) => {
                   e.preventDefault();
                   if (hideColorInfo) hideColorInfo();
                 }}
              >
                {color.name}
                <span/>
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
};
ColorSelector.propTypes = {
  colorInfo: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string,
      rgb: PropTypes.string,
    }),
  ),
  currentColorId: PropTypes.string,
  changeColor: PropTypes.func,
  showColorInfo: PropTypes.func,
  hideColorInfo: PropTypes.func,
};
ColorSelector.defaultProps = {
  colorInfo: null,
  currentColorId: null,
  changeColor: null,
  showColorInfo: null,
  hideColorInfo: null,
};

export default ColorSelector;



// WEBPACK FOOTER //
// ./src/containers/exterior-view/ColorSelector.jsx